<!-- 登陆页面 -->
<template>
    <div class="login-wrap">
        <div class="login-cont">
            <div class="cont-header">
                <i class="header-ico el-icon-arrow-left" @click="goBack"></i>
            </div>
            <div class="cont-main">
                <!--密码，验证码切换 头部-->
                <div class="switch-bar">
                    <p>绑定手机号</p>
                </div>
                <!-- 表单 -->
                <div class="form-box">
                    <el-form :model="loginForm" :rules="rules" ref="loginForm" label-width="0px" class="login-form">
                        <el-form-item prop="tel">
                            <label class="label-txt" for="">手机号</label>
                            <el-input v-model="loginForm.tel" placeholder="请输入手机号" maxlength="11" ref="tel" clearable>
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="code">
                            <label class="label-txt" for="">验证码</label>
                            <el-input type="txt" class="padding-right" placeholder="请输入验证码" maxlength="6"
                                v-model="loginForm.code" clearable>
                            </el-input>
                            <el-button v-show="codeSta" class="get-code-btn" @click="getCode()">获取验证码</el-button>
                            <el-button v-show="!codeSta" class="get-code-btn">{{ count }}s</el-button>
                        </el-form-item>
                        <el-form-item prop="pwd">
                            <label class="label-txt" for="">设置密码</label>
                            <el-input type="password" placeholder="至少6位数字和字母组合" v-model="loginForm.pwd" clearable
                                show-password>
                            </el-input>
                        </el-form-item>
                        <div class="login-btn">
                            <el-button type="primary" @click="submitForm('loginForm')"
                                :disabled="!loginForm.tel || !loginForm.code || !loginForm.pwd || !ischecked">登录
                            </el-button>
                        </div>
            
                    </el-form>
                </div>
    
            </div>
        </div>
    </div>
</template>

<script>
    import loginApi from '@/resources/loginModule/login'
    import config from '@/config'

    export default {
        data: function () {
            // 验证密码
            let checkPwd = (rule, value, callback) => {
                let reg = /^[0-9A-Za-z]{6,16}$/
                // let reg = /^\d{6,16}$/
                if (!value) {
                    return callback(new Error("请输入密码"));
                } else if (!reg.test(value)) {
                    return callback(new Error("请输入正确的密码"));
                } else {
                    callback();
                }
            };
            // 验证手机号
            let checkTel = (rule, value, callback) => {
                let reg = /^1[34578]\d{9}$/;
                if (!value) {
                    return callback(new Error("请输入手机号"));
                } else if (!reg.test(value)) {
                    return callback(new Error("请输入正确的手机号"));
                } else {
                    callback();
                }
            };
            return {
                loginWay: 1, //登录方式: 1 账号登录， 2 验证码登录
                codeSta: true, //获取验证码按钮状态
                count: "",
                timer: null,
                //表单数据
                loginForm: {
                    userName: "",
                    pwd: "",
                    tel: "",
                    code: ""
                },
                //校验
                rules: {
                    pwd: [{ required: true, validator: checkPwd, trigger: "blur" }],
                    tel: [{ required: true, validator: checkTel, trigger: "blur" }],
                    code: [{ required: true, message: "请输入验证码", trigger: "blur" }]
                },
                dialogVisible: false,
                ischecked: true,
            };
        },
        computed: {},
        created() { },
        mounted() { },
        methods: {
            // 获取验证码
            getCode() {
                if (!this.loginForm.tel) {
                    this.$message.warning("请输入手机号");
                } else {
                    this.sendMobileCode();
                }
            },
            // 验证码倒计时
            codeCountdown() {
                const TIME_COUNT = 60;
                if (!this.timer) {
                    this.count = TIME_COUNT;
                    this.codeSta = false;
                    this.timer = setInterval(() => {
                        if (this.count > 0 && this.count <= TIME_COUNT) {
                            this.count--;
                        } else {
                            this.codeSta = true;
                            clearInterval(this.timer);
                            this.timer = null;
                        }
                    }, 1000);
                }
            },
            // 手机号注册
            submitForm(formName) {
                var that = this;
                this.$refs[formName].validate(valid => {
                    if (valid) {

                        let para = {
                            mobile: that.loginForm.tel,
                            password: that.loginForm.pwd,
                            smsCode: that.loginForm.code,
                        };

                        loginApi.mobileRegister(para).then((res) => {
                            if (res.returnCode === 200) {
                                that.$router.push({ path: "/app/login" });
                                console.log("this.loginForm:", that.loginForm)
                            }
                        })
                    } else {
                        console.log("error submit!!");
                        return false;
                    }
                });
            },
            //发送验证码
            sendMobileCode() {
                let that = this;
                let para = {
                    mobile: that.loginForm.tel,
                    operationFlag: 1    //1.注册 2.忘记密码 3.登录 4.绑定手机号
                };
                loginApi.sendMobileCode(para).then((res) => {
                    if (res.returnCode === 200) {
                        that.codeCountdown();
                    } else if (res.returnCode === 40016) {
                        that.dialogVisible = true
                    }

                });
            },
            goBack() {
                this.$router.back()
            },
            toLogin() {
                this.$router.push({ path: "/app/login" });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },

        }
    };
</script>

<style scoped>
    @import "../../../assets/css/login/loginapp.css";
</style>